<template>
  <div class="pages">
    <div class="top flex flex-align-center flex-jus-between">
      <img class="arrow" src="../../static/images/icon-arrowLeft.png" @click="goBack">
      <div class="inp-box flex flex-align-center">
        <img class="search-icon" src="../../static/images/my/search.png">
        <input v-model.trim="search_text" type="text" placeholder="请输入关键字进行搜索">
      </div>
      <div @click="search" class="search-text">
        搜索
      </div>
    </div>
    <div v-if="isSearch">
      <van-tabs v-model="active" @change="changeVanTab">
        <van-tab title="综合">
          <tab1 @changeTab="changeTab" :activity="activity" :article="article" :learning_resource="learning_resource" :circle="circle"></tab1>
        </van-tab>
        <van-tab title="资讯">
          <tab2 ref="tab2" :search_text="search_text"></tab2>
        </van-tab>
        <van-tab title="活动">
          <tab3 ref="tab3" :search_text="search_text"></tab3>
        </van-tab>
        <van-tab title="资源">
          <tab4 ref="tab4" :search_text="search_text"></tab4>
        </van-tab>
        <van-tab title="友圈">
          <tab5 ref="tab5" :search_text="search_text"></tab5>
        </van-tab>
        <van-tab title="用户">
          <tab6 ref="tab6" :search_text="search_text"></tab6>
        </van-tab>
      </van-tabs>
    </div>
    <div v-if="history.length > 0 && !isSearch" class="history">
      <div class="flex flex-align-center flex-jus-between">
        <div class="history-title">搜索历史</div>
        <img @click="clearHistory" class="trash" src="../../static/images/my/trash.png">
      </div>
      <div class="historys flex flex-wrap">
        <div @click="search_text = item" v-for="item in history" :key="item" class="history-item">{{item}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import tab1 from './tab1.vue'
import tab2 from './tab2.vue'
import tab3 from './tab3.vue'
import tab4 from './tab4.vue'
import tab5 from './tab5.vue'
import tab6 from './tab6.vue'
export default {
  components: {
    tab1,
    tab2,
    tab3,
    tab4,
    tab5,
    tab6
  },
  data () {
    return {
      search_text: '',
      active: 0,
      isSearch: false,
      history: [],
      activity: [],
      article: [],
      circle: [],
      learning_resource: []
    };
  },
  watch: {
    search_text(val) {
      if (!val) {
        this.active = 0
        this.isSearch = false
        this.history = JSON.parse(localStorage.getItem('history')) || []
      }
    }
  },
  created() {
    this.history = JSON.parse(localStorage.getItem('history')) || []
  },
  mounted() {
    this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
  },
  methods: {
    goBack() {
      if (window.history.length <=1 ) {
        this.$router.push('/home')
      } else {
        this.$router.back(-1)
      }
    },
    clearHistory() {
      this.history = []
      localStorage.removeItem('history')
    },
    search() {
      if (!this.search_text) {
        this.$toast('请输入关键字')
        return
      }
      let history = JSON.parse(localStorage.getItem('history')) || []
      if (!history.includes(this.search_text)) {
        history.unshift(this.search_text)
        history = history.slice(0, 10)
        localStorage.setItem('history', JSON.stringify(history))
      }
      this.$get('api/index/multipleSearch', {
        search_text: this.search_text,
        article_limit: 3,
        activity_limit: 3,
        learning_resource_limit: 4,
        circle_limit: 5
      }).then(res => {
        let result = res.data
        this.activity = result.activity
        this.article = result.article
        this.circle = result.circle
        this.learning_resource = result.learning_resource
        this.isSearch = true
      })
      if (this.active != 0) {
        this.$nextTick(() => {
          this.$refs['tab'+(this.active+1)].getList()
        })
      }
    },
    changeTab(data) {
      this.active = data
      this.$nextTick(() => {
        this.$refs['tab'+(this.active+1)].getList()
      })
    },
    changeVanTab(data) {
      if (data == 0) return
      this.$nextTick(() => {
        this.$refs['tab'+(data + 1)].getList()
      })
    }
  }
}

</script>

<style lang='stylus' scoped>
.pages
  min-height 100vh
  padding-top 96px
.top
  z-index 99
  height 96px
  background #DE113C
  position fixed
  width 100%
  top 0
  left 0
  padding 0 30px
  .inp-box
    width 492px
    height 72px
    background #fff
    border-radius 72px
    padding 0 24px
    input
      background transparent
      line-height 72px
      height 72px
      font-size 26px
      color #000
  .search-text
    font-size 26px
    color #fff
.search-icon
  width 36px
  height 36px
  margin-right 24px
.arrow
  width 52px
  height 52px
.history
  padding 30px 30px 0
  .history-title
    font-size 26px
    color #2c2c2c
    line-height 36px
  .trash
    width 36px
    height 36px
  .historys
    margin-top 28px
    .history-item
      width 148px
      height 54px
      line-height 54px
      text-align center
      background #F2F2F2
      border-radius 28px
      font-size 24px
      color #666
      margin-right 24px
      margin-bottom 24px
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
</style>